var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "projects_map__heading_wrapper", style: _vm.style },
        [
          _c("div", { staticClass: "container" }, [
            _c("h2", { staticClass: "projects_map__heading" }, [
              _vm._v(_vm._s(_vm.title))
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "projects__map__select container" }, [
            _c("span", { staticClass: "projects__map__select__label" }, [
              _vm._v("View:")
            ]),
            _vm._v(" "),
            _c(
              "a",
              {
                class: {
                  projects__map__select__item: true,
                  projects__map__select__item__selected:
                    _vm.selectedCity === _vm.cities.MELBOURNE
                },
                on: {
                  click: function($event) {
                    _vm.selectCity(_vm.cities.MELBOURNE)
                  }
                }
              },
              [_vm._v("Melbourne")]
            ),
            _vm._v(" "),
            _c("span", { staticClass: "projects__map__select__separator" }, [
              _vm._v("|")
            ]),
            _vm._v(" "),
            _c(
              "a",
              {
                class: {
                  projects__map__select__item: true,
                  projects__map__select__item__selected:
                    _vm.selectedCity === _vm.cities.AUCKLAND
                },
                on: {
                  click: function($event) {
                    _vm.selectCity(_vm.cities.AUCKLAND)
                  }
                }
              },
              [_vm._v("Auckland")]
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "GmapMap",
        {
          ref: "mapRef",
          staticClass: "projects__map",
          attrs: { center: _vm.mapCenter, zoom: 11, options: _vm.mapOptions }
        },
        _vm._l(_vm.projectsToDisplay, function(project) {
          return _c("GmapMarker", {
            key: project.ID,
            attrs: { position: project.geolocation, icon: _vm.markerIcon },
            on: {
              click: function(event) {
                return _vm.onMarkerMouseOver(project, event)
              },
              mouseover: function(event) {
                return _vm.onMarkerMouseOver(project, event)
              },
              mouseout: function(event) {
                return _vm.onMarkerMouseLeave(event)
              }
            }
          })
        }),
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.selectedProject,
              expression: "selectedProject"
            }
          ],
          ref: "popperContainer",
          staticClass: "project-map__popper",
          on: { mouseleave: _vm.closePopper }
        },
        [_c("ProjectMapCard", { attrs: { project: _vm.selectedProject } })],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9368650c", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// /var/www/costimise/wp-content/themes/costimise/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9368650c","hasScoped":false,"optionsId":"0","buble":{"objectAssign":"Object.assign","transforms":{}}}!/var/www/costimise/wp-content/themes/costimise/node_modules/vue-loader/lib/selector.js?type=template&index=0!./scripts/vue/projects-map/ProjectsMap.vue
// module id = 194
// module chunks = 0